import React, { Component } from 'react';
import ISSDrawer from './Views/ISSDrawer';
import './index.css'
import { getData } from './Data/EventData';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';

const theme = createMuiTheme({
  palette: {
    type: 'light', // Switching the dark mode on is a single property value change.
    primary: blue,
    secondary: pink,
  },
  typography: {
    useNextVariants: true,
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { indexEvents: [], show: true };
  }

  onSetResult = (result) => {
    this.setState({ indexEvents: result, show: false });
  };

  componentDidMount() {
    getData().then(result => this.onSetResult(result)).catch((err) => {console.log(err)});
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <ISSDrawer title="37th International Seating Symposium" events={this.state.indexEvents} showLoading={this.state.show} displayLoadIndicator={(status) => this.setState({ show: status}) }/>
      </MuiThemeProvider>
    );
  }
}

export default App;
